import Api from "./Api"
const VISIBILITY_URL = {
    GET_SHIPMENT_JOURNEY: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/journey/${id}`,
    GET_CUTOFF_SEGREGATION: (id) => `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/cutoff/${id}`,
    CONTAINER_UPDATE: `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/container/update`,
    UPDATE_CUTOFFS: `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/cutoff`,
    CREATE_ERP_RECORD: `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/erp`,
    GET_ERP_STATUS: (id, type) => `${process.env.REACT_APP_API_SERVER}/api/v1/myactions/erp/${id}/${type}`,
}
export default class VisibilityApi {
    static getShipmentJourney(id) {
        return new Promise((resolve, reject) => {
            Api.fetch(VISIBILITY_URL.GET_SHIPMENT_JOURNEY(id), (data) => {
                resolve(data);
            });
        });
    }

    static async containerUpdate(container) {
         try {
            return await new Promise((resolve, reject) => {
                Api.post(VISIBILITY_URL.CONTAINER_UPDATE, container, (data) => {
                    resolve(data);
                });
            });
        } catch (error) {
            throw error;
        }
    }

    static getCutOffSegregation(id) {
        return new Promise((resolve, reject) => {
            Api.fetch(VISIBILITY_URL.GET_CUTOFF_SEGREGATION(id), (data) => {
                resolve(data);
            });
        });
    }

    static updateCutOffs(revisedValues) {
        return new Promise((resolve, reject) => {
            Api.post(VISIBILITY_URL.UPDATE_CUTOFFS, revisedValues, (data) => {
                resolve(data);
            });
        }).catch((error) => {
            throw error;
        });
    }

    static createErp(obj) {
        return new Promise((resolve, reject) => {
            Api.post(VISIBILITY_URL.CREATE_ERP_RECORD, obj, (data) => {
                resolve(data);
            });
        }).catch((error) => {
            throw error;
        });
    }

    static getBookingStatus(id, type) {
        return new Promise((resolve, reject) => {
            Api.fetch(VISIBILITY_URL.GET_ERP_STATUS(id, type), (data) => {
                resolve(data);
            });
        });
    }    
}